import axios from "axios";
import { platformApiApi } from "@capone/platform-api";
import { config } from "../../config";
import { SessionInfo } from "redmond";

export const fetchUserInfo = (): Promise<SessionInfo> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await platformApiApi(axios).apiV0UserInfoGet({
        baseURL: config.baseURL,
      });

      resolve(res.data as SessionInfo);
    } catch (e) {
      reject(e);
    }
  });

export default fetchUserInfo;
